import React from "react";
import { ShieldCheck, ShieldAlert, Loader2 } from "lucide-react";

/**
 * VerifiedBadge — shows the user's KYC verification state.
 *
 * Props:
 *   status: "approved" | "pending" | "rejected" | undefined
 *   type:   "individual" | "business" | undefined
 *   lang:   "ar" | "en"
 *   size:   "sm" | "md"
 */
export default function VerifiedBadge({ status, type, lang = "ar", size = "sm" }) {
  if (!status) return null;
  const isApproved = status === "approved";
  const isPending = status === "pending";
  const Icon = isApproved ? ShieldCheck : isPending ? Loader2 : ShieldAlert;

  const colors = isApproved
    ? { bg: "rgba(15,99,67,0.08)", border: "rgba(15,99,67,0.35)", fg: "#0a4f3a" }
    : isPending
      ? { bg: "rgba(201,165,92,0.10)", border: "rgba(201,165,92,0.40)", fg: "#8a6f2e" }
      : { bg: "rgba(220,38,38,0.08)", border: "rgba(220,38,38,0.30)", fg: "#b91c1c" };

  const label = isApproved
    ? type === "business"
      ? (lang === "ar" ? "تاجر موثّق" : "Verified Business")
      : (lang === "ar" ? "هوية موثّقة" : "Verified Identity")
    : isPending
      ? (lang === "ar" ? "قيد التحقق" : "Verification pending")
      : (lang === "ar" ? "التحقق مرفوض" : "Verification rejected");

  const cls = size === "md"
    ? "text-xs px-2.5 py-1"
    : "text-[10px] px-2 py-0.5";

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-semibold border ${cls}`}
      style={{ backgroundColor: colors.bg, borderColor: colors.border, color: colors.fg }}
      data-testid={`verified-badge-${status}`}
    >
      <Icon className={`${size === "md" ? "w-3.5 h-3.5" : "w-3 h-3"} ${isPending ? "animate-spin" : ""}`} />
      {label}
    </span>
  );
}
